import type { Field } from 'factorial-form'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import { WorkplaceType } from 'modules/ats/types/job'

interface WorkplaceTypeOption {
  value: WorkplaceType
  label: string
}

interface Props {
  field: Field
}

export const WorkplaceTypeSelect = ({ field }: Props) => {
  const options: WorkplaceTypeOption[] = [
    { value: WorkplaceType.Onsite, label: i18n.t('ats.workplace_types.onsite') },
    { value: WorkplaceType.Hybrid, label: i18n.t('ats.workplace_types.hybrid') },
    { value: WorkplaceType.Remote, label: i18n.t('ats.workplace_types.remote') },
  ]

  return (
    <Select
      none={i18n.t('ats.jobs_form.workplace_type_placeholder')}
      label={i18n.t('ats.jobs_form.workplace_type')}
      field={field}
      options={options}
      showOriginalLabelText
    />
  )
}
